import React from 'react';
import { Link } from 'react-router-dom';

export const LogButton = ({ filterType, filterValue, filterTypeName }) => (
  <span>
    <Link
      className="btn btn-secondary btn-sm"
      style={{ marginLeft: '5px' }}
      to={{
        pathname: '/auditlogs',
        state: { filterType, filterValue, filterTypeName },
      }}
    >
      <i className="fa fa-file-text-o" />
    </Link>
  </span>
);

export default LogButton;



// WEBPACK FOOTER //
// ./src/components/common/Tables/LogButton.jsx